/* eslint-disable @typescript-eslint/naming-convention */
export enum UserConsentIdEnum {
    EREZEPT = 'EINW_EREZEPT',
    MEDCOACH = 'EINW_MEDCOACH',
    POST = 'EINW_MEINEBIG_POST',
}
